import React from 'react';

import TagIcon from 'components/ObjectiveTagList/TagIcon';
import { EmptyBar } from 'screens/analytics/commonComponents';
import styled, { css } from 'styled-components';
import { FlexContainer, StyledTooltip } from 'styles/common';

import {
  ArrowThickDownIcon,
  ArrowThickLeftIcon,
  ArrowThickRightIcon,
  ArrowThickUpIcon,
  PlusIcon2,
} from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import SimpleAvatarGroup from 'uiToolkit/SimpleAvatarGroup';
import { Typography7, Typography4 } from 'uiToolkit/Typography';

import GoalList from '../GoalList';

const CardWrapper = styled.div`
  height: 80px;
  width: 300px;
  ${(props) =>
    props.showGoalsSection &&
    css`
      height: 188px;
      width: 301px;
      border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
    `};
  ${'' /* background: white; */}
  border-radius: 4px;
  ${
    '' /* padding-left: 24px;
  position: relative; */
  }
  margin-top: 32px;
  position: relative;
`;

const ObjectiveWrapper = styled.div`
  height: 80px;
  width: 300px;
  background: ${(props) => props.theme.palette.background.paper};
  border-radius: 4px;
  border: 1px solid ${(props) => props.statusColor ?? props.theme.palette.borders.blue};
  padding-left: 24px;
  ${'' /* margin-top: 32px; */}
  cursor: ${(props) => (props.showPointer ? 'pointer' : 'inherit')}
`;

const GoalsListWrapper = styled.div`
  height: 106px;
  width: 299px;
  background: ${(props) => props.theme.palette.background.paper};
`;

const OptionsWrapper = styled.div`
  position: absolute;
  right: -1px;
  bottom: -32px;
`;

const GoalsExpandButtonWrapper = styled.div`
  position: absolute;
  left: 192px;
  bottom: ${(props) => (props.showGoalsSection ? '135px' : '28px')};
`;

const ObjectiveGoalMembersWrapper = styled.div`
  position: absolute;
  left: -1px;
  bottom: -32px;
`;

const ExpandCollapseWrapper = styled.div`
  position: absolute;
  right: -32px;
  top: ${(props) => (props.showGoalsSection ? '80px' : '28px')};
`;

const AggregatePercentWrapper = styled.div`
  width: 79px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.statusColor};
  border-radius: 4px;
  background: ${(props) => `${props.statusColor}30`};
  margin-right: -1px;
  margin-top: -1px;
`;

const ExpandCollapseButton = ({ isExpanded, onClick }) => {
  const Icon = () => (isExpanded ? <ArrowThickLeftIcon size="fixed10px" /> : <ArrowThickRightIcon size="fixed10px" />);
  return <CircularOutlineIcon onClick={() => onClick(!isExpanded)} color="primary" icon={Icon} />;
};

const ObjectiveNode = ({
  objective,
  isExpanded = false,
  goalsAggregatePercentage,
  onExpandClick,
  hasChildNodes = false,
  goalsCount = 0,
  isGoalsExpanded = false,
  goalMembers = [],
  goalEmployeesCount,
  statusColor = theme.palette.primary.main,
  onGoalsExpandToggle,
  onGoalObjectiveCreationClick,
  onGoalCreationClick,
  forceUpdateValue,
  enableObjectiveCreation = false,
}) => {
  const showGoalsSection = goalsCount > 0 && isGoalsExpanded;
  const withStopPropagation = (e) => {
    e.stopPropagation();
    enableObjectiveCreation && onGoalObjectiveCreationClick();
    !enableObjectiveCreation && onGoalCreationClick();
  };

  return (
    <CardWrapper showGoalsSection={showGoalsSection}>
      <ObjectiveWrapper
        statusColor={statusColor}
        onClick={() => {
          goalsCount > 0 && onGoalsExpandToggle();
        }}
        showPointer={goalsCount > 0}
      >
        <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ flexGrow: 1, display: 'flex', marginRight: '32px' }}>
            <TagIcon tagId={objective.objectiveLevel ? objective.objectiveLevel : undefined} />

            <StyledTooltip title={objective.displayName}>
              <div style={{ width: '131px' }}>
                <Typography4 truncate leftGutter={2}>
                  {objective.displayName}
                </Typography4>
              </div>
            </StyledTooltip>
          </div>
          <AggregatePercentWrapper statusColor={statusColor}>
            {goalsAggregatePercentage ? (
              <Typography7 customColor={statusColor}>{goalsAggregatePercentage}%</Typography7>
            ) : (
              <EmptyBar />
            )}
          </AggregatePercentWrapper>
        </FlexContainer>

        {hasChildNodes && (
          <ExpandCollapseWrapper showGoalsSection={showGoalsSection}>
            <ExpandCollapseButton isExpanded={isExpanded} onClick={onExpandClick} />
          </ExpandCollapseWrapper>
        )}

        <OptionsWrapper>
          <CircularOutlineIcon onClick={withStopPropagation} color="primary" icon={PlusIcon2} />
        </OptionsWrapper>

        {goalsCount > 0 && (
          <GoalsExpandButtonWrapper showGoalsSection={showGoalsSection}>
            {isGoalsExpanded ? (
              <ArrowThickUpIcon size="fixed12px" color={theme.palette.icons.grey2} />
            ) : (
              <ArrowThickDownIcon size="fixed12px" color={theme.palette.icons.grey2} />
            )}
          </GoalsExpandButtonWrapper>
        )}

        <ObjectiveGoalMembersWrapper>
          <SimpleAvatarGroup employees={goalMembers} totalEmployeesCount={goalEmployeesCount} maxAvatarsToShow={3} />
        </ObjectiveGoalMembersWrapper>
      </ObjectiveWrapper>
      {showGoalsSection && (
        <GoalsListWrapper>
          <GoalList objective={objective} forceUpdateValue={forceUpdateValue} />
        </GoalsListWrapper>
      )}
    </CardWrapper>
  );
};

export default ObjectiveNode;
